(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);
if (!customElements.get('qatamin-header-enhancement')) {
  customElements.define('qatamin-header-enhancement', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.root = this.closest('.header-wrapper');
      if (!this.root) return;
      const root = this.root;
      const products = root.querySelector('[data-qn-products]');
      const cycle = root.querySelector('[data-qn-cycle]');
      const brand = root.querySelector('[data-qn-brand]');
      const routineUrl = this.dataset.routineUrl;
      if (!root.hasAttribute('data-qn-enhanced')) {
      root.querySelectorAll('.header__inline-menu a, .menu-drawer__menu-item').forEach(link => {
        if (link.getAttribute('href')?.split('?')[0] !== routineUrl) return;
        link.classList.add('qn-routine-link');
        if (!link.querySelector('.qn-cycle')) link.prepend(cycle.content.cloneNode(true));
      });
      this.shop = [...root.querySelectorAll('.header__inline-menu header-menu > details')].find(details => details.querySelector('a[href$="/collections/all"]'));
      if (this.shop) {
        const panel = this.shop.querySelector('summary').nextElementSibling;
        this.shop.classList.add('qn-shop-details');
        panel.classList.add('qn-shop-panel');
        if (panel.tagName === 'UL') {
          panel.classList.add('qn-shop-panel--dropdown');
          const categoriesItem = document.createElement('li');
          const categories = document.createElement('ul');
          categories.className = 'qn-categories';
          categories.setAttribute('role', 'list');
          while (panel.firstChild) categories.append(panel.firstChild);
          categoriesItem.append(categories);
          const featureItem = document.createElement('li');
          featureItem.append(products.content.cloneNode(true));
          panel.append(categoriesItem, featureItem);
        } else {
          panel.classList.add('qn-shop-panel--mega');
          panel.querySelector('ul').classList.add('qn-categories');
          panel.append(products.content.cloneNode(true));
        }
      }
      const mobileShop = [...root.querySelectorAll('.menu-drawer__inner-submenu')].find(panel => panel.querySelector('a[href$="/collections/all"]'));
      if (mobileShop) {
        const picks = products.content.cloneNode(true);
        picks.querySelector('.qn-picks').classList.add('qn-mobile-products');
        mobileShop.append(picks);
      }
      root.querySelector('.menu-drawer__navigation')?.prepend(brand.content.cloneNode(true));
      root.classList.add('qn-header');
      root.setAttribute('data-qn-enhanced', '');
      }
      this.shop = root.querySelector('.qn-shop-details');
      this.desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      const disclosures = [...root.querySelectorAll('.header__inline-menu header-menu > details')];
      const close = details => {
        details.removeAttribute('open');
        details.querySelector('summary').setAttribute('aria-expanded', 'false');
      };
      disclosures.forEach(details => {
        details.addEventListener('pointerenter', () => {
          if (!this.desktop.matches) return;
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => {
            disclosures.filter(item => item !== details).forEach(close);
            details.setAttribute('open', '');
            details.querySelector('summary').setAttribute('aria-expanded', 'true');
          }, 140);
        }, { signal });
        details.addEventListener('pointerleave', () => {
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => {
            if (this.desktop.matches && !details.contains(document.activeElement)) close(details);
          }, 220);
        }, { signal });
        details.addEventListener('toggle', () => {
          if (details.open) disclosures.filter(item => item !== details).forEach(close);
        }, { signal });
      });
      root.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = disclosures.find(details => details.open);
        if (!open) return;
        close(open);
        open.querySelector('summary').focus();
        event.stopPropagation();
      }, { signal });
      document.addEventListener('pointerdown', event => {
        if (!root.contains(event.target)) disclosures.forEach(close);
      }, { signal });
      this.desktop.addEventListener('change', () => disclosures.forEach(close), { signal });
      this.widthMedia = window.matchMedia('(min-width: 990px)');
      this.widthMedia.addEventListener('change', event => {
        disclosures.forEach(close);
        const drawer = root.querySelector('header-drawer');
        if (!event.matches || !drawer?.querySelector('details[open]')) return;
        drawer.closeMenuDrawer(null, root.querySelector('.header__heading-link'));
        drawer.querySelector('summary').setAttribute('aria-expanded', 'false');
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qatamin-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qatamin-routine')) {
    customElements.define('qatamin-routine', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.modeLinks = [...this.querySelectorAll('[data-mode-button]')];
        this.panels = [...this.querySelectorAll('[data-routine-panel]')];
        this.toggle = this.querySelector('[data-motion-toggle]');
        this.handleClick = event => {
          const control = event.target.closest('[data-mode-button], [data-switch-mode], [data-motion-toggle]');
          if (!control || !this.contains(control)) return;
          if (control.hasAttribute('data-motion-toggle')) {
            const paused = this.dataset.motion !== 'off';
            this.dataset.motion = paused ? 'off' : 'on';
            control.setAttribute('aria-pressed', String(paused));
            return;
          }
          event.preventDefault();
          const mode = control.dataset.modeButton || control.dataset.switchMode;
          this.setMode(mode);
          if (control.hasAttribute('data-switch-mode')) {
            const heading = this.querySelector(`[data-routine-panel="${mode}"] h2`);
            heading.focus({ preventScroll: true });
            this.querySelector('.qr-controls').scrollIntoView({ behavior: this.reduced.matches ? 'instant' : 'smooth', block: 'start' });
          }
        };
        this.addEventListener('click', this.handleClick);
        this.toggle.hidden = false;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
        this.querySelectorAll('[data-reveal]').forEach(item => this.observer.observe(item));
        this.classList.add('is-ready');
        this.resizeObserver = new ResizeObserver(() => this.drawTrail());
        this.resizeObserver.observe(this);
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            const panel = this.querySelector('[data-routine-panel]:not([hidden])');
            if (!panel) return;
            const rect = panel.getBoundingClientRect();
            const distance = Math.max(1, rect.height - window.innerHeight * .45);
            const progress = Math.max(0, Math.min(1, (window.innerHeight * .4 - rect.top) / distance));
            this.style.setProperty('--qr-progress', progress);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        const hash = window.location.hash;
        const initial = hash.includes('Qr-evening-') ? 'evening' : 'morning';
        this.setMode(initial);
      }
      setMode(mode) {
        if (!['morning', 'evening'].includes(mode)) return;
        this.dataset.mode = mode;
        this.panels.forEach(panel => { panel.hidden = panel.dataset.routinePanel !== mode; });
        this.modeLinks.forEach(link => link.setAttribute('aria-current', String(link.dataset.modeButton === mode)));
        requestAnimationFrame(() => { this.drawTrail(); this.onScroll(); });
      }
      drawTrail() {
        const map = this.querySelector('[data-routine-panel]:not([hidden]) .qr-map');
        if (!map) return;
        const bounds = map.getBoundingClientRect();
        const nodes = [...map.querySelectorAll('.qr-node')].map(node => {
          const rect = node.getBoundingClientRect();
          return { x: rect.left + rect.width / 2 - bounds.left, y: rect.top + rect.height / 2 - bounds.top };
        });
        if (!nodes.length) return;
        const mobile = bounds.width < 700;
        let d = `M ${nodes[0].x} 0 L ${nodes[0].x} ${nodes[0].y}`;
        nodes.slice(1).forEach((point, index) => {
          const previous = nodes[index];
          const bend = mobile ? 0 : (index % 2 ? -72 : 72);
          d += ` C ${previous.x + bend} ${previous.y + (point.y - previous.y) * .4}, ${point.x + bend} ${point.y - (point.y - previous.y) * .4}, ${point.x} ${point.y}`;
        });
        d += ` L ${nodes[nodes.length - 1].x} ${bounds.height}`;
        const svg = map.querySelector('.qr-trail');
        svg.setAttribute('viewBox', `0 0 ${bounds.width} ${bounds.height}`);
        svg.querySelectorAll('path').forEach(line => line.setAttribute('d', d));
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
